import { TimelineItem } from '../TimelineItem';

export const TIMELINE_DATA: TimelineItem[] = [
  {
    title: '2025',
    contents: [
      {
        date: 'december',
        items: [{ description: '2025.text4', isHighlight: true }],
      },
      {
        date: 'april',
        items: [{ description: '2025.text3', isHighlight: true }],
      },
      {
        date: 'march',
        items: [{ description: '2025.text2' }],
      },
      {
        date: 'january',
        items: [{ description: '2025.text1' }],
      }
    ],
  },
  {
    title: '2024',
    contents: [
      {
        date: 'april',
        items: [{ description: '2024.text1' }],
      },
    ],
  },
  {
    title: '2023',
    contents: [
      {
        date: 'december',
        items: [
          { description: '2023.text15', isHighlight: true },
          { description: '2023.text14', isHighlight: true },
        ],
      },
      {
        date: 'november',
        items: [{ description: '2023.text13', isHighlight: true }],
      },
      {
        date: 'october',
        items: [{ description: '2023.text12' }],
      },
      {
        date: 'september',
        items: [
          { description: '2023.text11', isHighlight: true },
          { description: '2023.text10' },
          { description: '2023.text9' },
          { description: '2023.text8' },
        ],
      },
      {
        date: 'august',
        items: [{ description: '2023.text7' }],
      },
      {
        date: 'june',
        items: [{ description: '2023.text6' }, { description: '2023.text5' }],
      },
      {
        date: 'may',
        items: [{ description: '2023.text4' }, { description: '2023.text3' }],
      },
      {
        date: 'april',
        items: [{ description: '2023.text2' }],
      },
      {
        date: 'february',
        items: [{ description: '2023.text1', isHighlight: true }],
      },
    ],
  },
  {
    title: '2022',
    contents: [
      {
        date: 'december',
        items: [{ description: '2022.text1' }],
      },
      {
        date: 'november',
        items: [{ description: '2022.text2', isHighlight: true }],
      },
      {
        date: 'august',
        items: [{ description: '2022.text3' }],
      },
      {
        date: 'june',
        items: [{ description: '2022.text4' }],
      },
      {
        date: 'may',
        items: [{ description: '2022.text5', isHighlight: true }],
      },
      {
        date: 'april',
        items: [{ description: '2022.text6' }],
      },
      {
        date: 'march',
        items: [{ description: '2022.text7', isHighlight: true }],
      },
      {
        date: 'february',
        items: [{ description: '2022.text8' }],
      },
      {
        date: 'january',
        items: [{ description: '2022.text9', isHighlight: true }],
      },
    ],
  },
  {
    title: '2021',
    contents: [
      {
        date: 'december',
        items: [{ description: '2021.text1' }],
      },
      {
        date: 'november',
        items: [{ description: '2021.text2', isHighlight: true }],
      },
      {
        date: 'october',
        items: [{ description: '2021.text3' }],
      },
      {
        date: 'september',
        items: [{ description: '2021.text4' }],
      },
      {
        date: 'august',
        items: [{ description: '2021.text5', isHighlight: true }],
      },
    ],
  },
  {
    title: '2020',
    contents: [
      {
        date: 'december',
        items: [{ description: '2020.text1' }],
      },
      {
        date: 'march',
        items: [{ description: '2020.text2', isHighlight: true }],
      },
      {
        date: 'february',
        items: [{ description: '2020.text3' }],
      },
    ],
  },
  {
    title: '2019',
    contents: [
      {
        date: 'october',
        items: [{ description: '2019.text1' }],
      },
    ],
  },
];
